<script setup lang="ts">
import useFilterSearchPreDefinedValues from '~/composables/filter/useFilterSearchPreDefinedValues'
import type { EstateType } from '~/types/EstateType'

const { locale } = useI18n()
const props = defineProps<{
  estateType: EstateType
}>()

const preDefinedSearchValues = useFilterSearchPreDefinedValues()
const filterLinks = computed(() => {
  return preDefinedSearchValues[props.estateType][locale.value].map((name) => ({
    name,
    link: getEstateListingLink({
      estateType: props.estateType,
    }),
  }))
})

function onClicked() {
  const scrollEl = document.querySelector('#listing-scroll-hook') as HTMLElement

  if (!scrollEl) return

  scrollToElement({
    element: scrollEl,
    ignoreHeaderHeight: true,
  })
}
</script>

<template>
  <div class="c-header-most-searched">
    <h2 class="c-header-most-searched__title">
      {{ $t('pages.estateListing.header.mostSearchedTitle') }}
    </h2>

    <div class="c-header-most-searched__buttons">
      <!-- <template v-if="!officesResponse && officesPending">
        <div v-for="i in 8" :key="i" class="sc-skeleton" />
      </template>

      <template v-else>
        ...
      </template> -->

      <IButton
        v-for="item in filterLinks"
        :key="item.name"
        :to="`${item.link?.fullPath}/${removeDiacriticsAndNormalize(item.name)}`"
        color="light"
        @click="onClicked"
      >
        <div class="sc-name">{{ item.name }}</div>
        <!-- <div class="sc-count">{{ `(${item.count})` }}</div> -->
      </IButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;
@use '@/assets/styles/mixins/skeleton' as skeleton;

.c-header-most-searched {
  &__title {
    font-family: var(--font-family-primary-base);
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 8px;

    .sc-skeleton {
      @include skeleton.skeleton;

      --skeleton-background-color: hsla(
        var(--color-light-h),
        var(--color-light-s),
        var(--color-light-l),
        0.1
      );
      --skeleton-loader-opacity: 0.2;
      --skeleton-loader-color: var(--color-light);

      height: 34px;
      width: var(--skeleton-width);
      border-radius: 2px;

      &:nth-child(1) {
        --skeleton-width: 108px;
      }
      &:nth-child(2) {
        --skeleton-width: 95px;
      }
      &:nth-child(3) {
        --skeleton-width: 109px;
      }
      &:nth-child(4) {
        --skeleton-width: 92px;
      }
      &:nth-child(5) {
        --skeleton-width: 93px;
      }
      &:nth-child(6) {
        --skeleton-width: 129px;
      }
      &:nth-child(7) {
        --skeleton-width: 93px;
      }
      &:nth-child(8) {
        --skeleton-width: 116px;
      }
    }

    .router-link-exact-active {
      background-color: var(--color-secondary-600);
    }

    :deep(.button) {
      min-height: 34px;
      --button--gap: 6px;
      --button--font-size: 15px;
      --button--padding-top: 8px;
      --button--padding-bottom: 8px;
      --button--padding-left: 16px;
      --button--padding-right: 16px;
      --button--color: var(--color-dark);
      --button--font-weight: 500;
      --button--hover--background: var(--color-secondary);
      --button--active--background: var(--color-secondary-600);

      .sc-count {
        opacity: 0.46;
      }
    }
  }
}
</style>
